import React from 'react';
import { useSelector } from 'react-redux';

export const useAccount = () => {
  return useSelector(({ account }) => ({
    ...account,
    myCustomerId: account.user?.profile?.id,
  }));
};
